export default __webpack_public_path__ + "static/media/banner.2be4bb17.mp4";